(() => {
  const storageKey = 'hedera_wholesale_quote_v1';

  const readItems = () => {
    try {
      const value = JSON.parse(window.localStorage.getItem(storageKey) || '[]');
      if (!Array.isArray(value)) return [];
      return value.filter((item) => item && item.productId && item.title).map((item) => ({
        productId: String(item.productId),
        variantId: String(item.variantId || ''),
        title: String(item.title),
        variantTitle: String(item.variantTitle || ''),
        url: String(item.url || ''),
        quantity: Math.max(1, Number.parseInt(item.quantity, 10) || 1)
      }));
    } catch (error) {
      return [];
    }
  };

  let items = readItems();
  let toastTimer;
  const labelTimers = new WeakMap();
  const quoteRoot = (button) => button.closest('[data-hd-wholesale-root]') || document.querySelector('[data-hd-wholesale-root]');

  const saveItems = () => {
    try {
      window.localStorage.setItem(storageKey, JSON.stringify(items));
    } catch (error) {
      return;
    }
  };

  const itemKey = (item) => `${item.productId}:${item.variantId}`;

  const quoteText = () => items.map((item, index) => {
    const variant = item.variantTitle && item.variantTitle !== 'Default Title' ? ` — ${item.variantTitle}` : '';
    const link = item.url ? ` — ${window.location.origin}${item.url}` : '';
    return `${index + 1}. ${item.title}${variant} — ${window.hederaUiText("quantity")}: ${item.quantity}${link}`;
  }).join('\n');

  const createQuoteItem = (item) => {
    const row = document.createElement('div');
    row.className = 'hd-wholesale-quote__item';
    row.dataset.quoteKey = itemKey(item);

    const link = document.createElement('a');
    link.className = 'hd-wholesale-quote__name';
    link.href = item.url || '#';
    link.textContent = item.title;
    if (item.variantTitle && item.variantTitle !== 'Default Title') {
      const variant = document.createElement('span');
      variant.className = 'hd-wholesale-quote__variant';
      variant.textContent = item.variantTitle;
      link.appendChild(variant);
    }

    const quantity = document.createElement('input');
    quantity.className = 'hd-wholesale-quote__quantity';
    quantity.type = 'number';
    quantity.min = '1';
    quantity.step = '1';
    quantity.value = String(item.quantity);
    quantity.setAttribute('aria-label', window.hederaUiText("quote_quantity", { title: item.title }));
    quantity.dataset.hdQuoteQuantity = '';

    const remove = document.createElement('button');
    remove.className = 'hd-wholesale-quote__remove';
    remove.type = 'button';
    remove.textContent = window.hederaUiText("remove");
    remove.setAttribute('aria-label', window.hederaUiText("quote_remove", { title: item.title }));
    remove.dataset.hdQuoteRemove = '';

    row.append(link, quantity, remove);
    return row;
  };

  const render = () => {
    document.querySelectorAll('[data-hd-quote-count]').forEach((counter) => {
      counter.textContent = String(items.length);
    });

    document.querySelectorAll('[data-hd-quote-box]').forEach((box) => {
      box.hidden = false;
      box.classList.toggle('is-empty', items.length === 0);
      const empty = box.querySelector('[data-hd-quote-empty]');
      if (empty) empty.hidden = items.length !== 0;
      const list = box.querySelector('[data-hd-quote-items]');
      if (list) list.replaceChildren(...items.map(createQuoteItem));
    });

    document.querySelectorAll('[data-hd-quote-output]').forEach((output) => {
      output.value = quoteText();
    });

    document.querySelectorAll('[data-hd-quote-manual]').forEach((field) => {
      const mustRequire = field.dataset.required === 'true' && items.length === 0;
      field.required = mustRequire;
      field.setAttribute('aria-required', mustRequire ? 'true' : 'false');
    });

    document.querySelectorAll('[data-hd-wholesale-catalog] [data-hd-wholesale-product]').forEach((card) => {
      const button = card.querySelector('[data-hd-quote-add]');
      if (!button) return;
      const selection = selectedData(button);
      const selected = items.find((item) => itemKey(item) === itemKey(selection));
      const status = card.querySelector('[data-hd-quote-card-status]');
      const quantity = card.querySelector('[data-hd-quote-card-quantity]');
      if (status) status.hidden = !selected;
      if (quantity) quantity.textContent = selected ? String(selected.quantity) : '0';
      card.classList.toggle('is-in-quote', Boolean(selected));
      card.querySelectorAll('[data-hd-quote-details]').forEach((link) => {
        const url = new URL(button.dataset.productUrl, window.location.origin);
        url.searchParams.set('variant', selection.variantId);
        link.href = url.pathname + url.search;
      });
    });
  };

  const hideToast = (toast) => {
    if (!toast) return;
    toast.classList.remove('is-visible');
    window.setTimeout(() => {
      if (!toast.classList.contains('is-visible')) toast.hidden = true;
    }, 220);
  };

  const showToast = (button) => {
    const root = quoteRoot(button);
    const toast = root ? root.querySelector('[data-hd-quote-toast]') : null;
    if (!toast) return;
    window.clearTimeout(toastTimer);
    toast.hidden = false;
    window.requestAnimationFrame(() => toast.classList.add('is-visible'));
    const duration = Math.max(2000, Number.parseInt(toast.dataset.duration, 10) || 4500);
    toastTimer = window.setTimeout(() => hideToast(toast), duration);
  };

  const showQuoteBox = (button) => {
    const root = quoteRoot(button);
    const box = root ? root.querySelector('[data-hd-quote-box]') : document.querySelector('[data-hd-quote-box]');
    if (!box) return;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    box.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
    box.focus({ preventScroll: true });
    box.classList.remove('is-highlighted');
    window.requestAnimationFrame(() => box.classList.add('is-highlighted'));
    const duration = Math.max(500, Number.parseInt(root?.dataset.hdQuoteHighlightDuration, 10) || 1500);
    window.setTimeout(() => box.classList.remove('is-highlighted'), duration);
    hideToast(root ? root.querySelector('[data-hd-quote-toast]') : null);
  };

  const selectedData = (button) => {
    const data = {
      productId: button.dataset.productId || '',
      variantId: button.dataset.variantId || '',
      title: button.dataset.productTitle || '',
      variantTitle: button.dataset.variantTitle || '',
      url: button.dataset.productUrl || '',
      quantity: 1
    };
    const productRoot = button.closest('[data-hd-wholesale-product]');
    const variantSelect = productRoot ? productRoot.querySelector('[data-hd-wholesale-variant]') : null;
    if (variantSelect && variantSelect.selectedOptions.length) {
      const option = variantSelect.selectedOptions[0];
      data.variantId = option.value;
      data.variantTitle = option.dataset.variantTitle || option.textContent.trim();
    }
    if (button.closest('[data-hd-wholesale-catalog]') && data.url) {
      const url = new URL(data.url, window.location.origin);
      url.searchParams.set('variant', data.variantId);
      data.url = url.pathname + url.search;
    }
    return data;
  };

  const addItem = (button) => {
    const next = selectedData(button);
    if (!next.productId || !next.title) return;
    const key = itemKey(next);
    const existing = items.find((item) => itemKey(item) === key);
    if (existing) existing.quantity += 1;
    else items.push(next);
    saveItems();
    render();

    const originalLabel = button.dataset.defaultLabel || button.textContent;
    window.clearTimeout(labelTimers.get(button));
    button.textContent = button.dataset.addedLabel || window.hederaUiText("added");
    labelTimers.set(button, window.setTimeout(() => {
      if (button.isConnected) button.textContent = originalLabel;
    }, 1600));

    showToast(button);

    if (button.dataset.quoteUrl) {
      window.setTimeout(() => {
        window.location.href = button.dataset.quoteUrl;
      }, 260);
    }
  };

  document.addEventListener('click', (event) => {
    const addButton = event.target.closest('[data-hd-quote-add]');
    if (addButton) {
      event.preventDefault();
      addItem(addButton);
      return;
    }

    const viewButton = event.target.closest('[data-hd-quote-view]');
    if (viewButton) {
      event.preventDefault();
      showQuoteBox(viewButton);
      return;
    }

    const removeButton = event.target.closest('[data-hd-quote-remove]');
    if (!removeButton) return;
    const row = removeButton.closest('[data-quote-key]');
    if (!row) return;
    items = items.filter((item) => itemKey(item) !== row.dataset.quoteKey);
    saveItems();
    render();
  });

  document.addEventListener('change', (event) => {
    if (event.target.matches('[data-hd-wholesale-variant]')) {
      render();
      return;
    }
    if (!event.target.matches('[data-hd-quote-quantity]')) return;
    const row = event.target.closest('[data-quote-key]');
    if (!row) return;
    const item = items.find((candidate) => itemKey(candidate) === row.dataset.quoteKey);
    if (!item) return;
    item.quantity = Math.max(1, Number.parseInt(event.target.value, 10) || 1);
    event.target.value = String(item.quantity);
    saveItems();
    render();
  });

  document.addEventListener('shopify:section:load', render);
  window.addEventListener('storage', (event) => {
    if (event.key !== storageKey) return;
    items = readItems();
    render();
  });

  document.querySelectorAll('[data-hd-quote-success]').forEach(() => {
    items = [];
    saveItems();
  });

  document.addEventListener('click', (event) => {
    const thumbnail = event.target.closest('[data-hd-wholesale-thumb]');
    if (!thumbnail) return;
    const gallery = thumbnail.closest('[data-hd-wholesale-gallery]');
    const image = gallery ? gallery.querySelector('.hd-wholesale-product__main-image') : null;
    if (!image || !thumbnail.dataset.imageUrl) return;
    image.src = thumbnail.dataset.imageUrl;
    image.srcset = '';
    gallery.querySelectorAll('[data-hd-wholesale-thumb]').forEach((item) => item.setAttribute('aria-current', 'false'));
    thumbnail.setAttribute('aria-current', 'true');
  });

  render();
})();
